export default __webpack_public_path__ + "ef512aa4e9a9ec8208544c1c200bd2a7.svg";